import { useDataSubmit, useDataValue } from 'Simple/Data'
import { isEmpty } from 'Data/format.js'

export function useOnKeyUp(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'question',
  })

  let question = useDataValue({
    viewPath: props.viewPath,
    context: 'question',
  })

  return function onKeyUp(event) {
    if (event.key === 'Enter' && question.isValid) {
      submit({ type: 'next' })
    }
  }
}

export function sanitise(value) {
  return value?.skipped ? '' : value
}

export function markAsInvalid(isValid, value) {
  return isEmpty(value) || isValid
}

export function shouldAutoFocus(autoFocus, order) {
  return autoFocus !== false && order !== 1
}
